import { ErrorInputSchema } from '../error.js';
import { StepFunctionTaskRequestSchema } from '../request.js';
import { GatherTemplateTokensInputSchema } from './gatherTemplateTokens.js';
export const RecordDraftDocumentResultsInputSchema = GatherTemplateTokensInputSchema.extend({
    errorResults: ErrorInputSchema.optional(),
});
export const RecordDraftDocumentResultsRequestSchema = StepFunctionTaskRequestSchema.extend({
    input: RecordDraftDocumentResultsInputSchema,
});
